import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: 'auto',
  gap: theme.spacing(6),
  maxWidth: theme.spacing(135.5),
  '& .FLLogo': {
    height: theme.spacing(16),
    width: theme.spacing(28.75),
  },
  '& .FLLinksContainer': {
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
    flexWrap: 'wrap',
    justifyContent: 'center',
    textAlign: 'center',
  },
  '& .FLLinksRowContainer': {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    gap: theme.spacing(6),
    flexWrap: 'wrap',
    '&:first-child': {
      [theme.breakpoints.down('lg')]: {
        maxWidth: theme.spacing(62.5),
      },
    },
    '&:nth-child(2)': {
      [theme.breakpoints.down('md')]: {
        maxWidth: theme.spacing(35.625),
        margin: 'auto',
      },
    },
  },
  '& .FLLink': {
    color: theme.palette.common.white,
  },
  '& .FLDownloadBtnsContainer': {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(2),
    },
  },
  '& .FLDownloadBtns': {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
  },
  '& .FLDownloadBtn': {
    [theme.breakpoints.down('md')]: {
      width: `${theme.typography.pxToRem(95)} !important`,
    },
  },
}));

export default StyledBox;
